import MUIAppBar from "@mui/material/AppBar";

const AppBar = MUIAppBar;

export default AppBar;
